import { Button } from "@mui/material";
import * as React from "react";
import { resolvePath } from "react-router-dom";
import { useLanguage } from "../../Language";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

export const BackToLink = () => {
  const { translate } = useLanguage();
  // TODO use context instead
  const backToLinkParam = sessionStorage.getItem("backToLink");
  const backToText = sessionStorage.getItem("backToLinkText");

  const backToLink = React.useMemo(() => {
    if (!backToLinkParam) {
      return null;
    }
    try {
      const location = JSON.parse(backToLinkParam);
      const { pathname, search } = resolvePath(location);
      if (pathname.startsWith("/section=")) {
        return `#${pathname.substring(1)}`; // remove leading slash for legacy routes
      } else {
        return `#${pathname}${search}`;
      }
    } catch (e) {
      return null;
    }
  }, [backToLinkParam]);

  return (
    <>
      {backToLink && (
        <Button href={backToLink} onClick={() => {
            sessionStorage.removeItem("backToLink");
            sessionStorage.removeItem("backToLinkText");
            window.location.hash = backToLink;
        }} startIcon={<KeyboardBackspaceIcon />}>
          {translate("backTo")} {backToText}
        </Button>
      )}
    </>
  );
};
